import module_851b001f8ac6432e8ba87b29e48eac04 from '../includes/glsl-compat.frag'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\nprecision '+
(obj.highp)+
' float;\n\n'+
(module_851b001f8ac6432e8ba87b29e48eac04())+
'\n\n\nIN vec2 vTexCoord;\nuniform sampler2D tTex;\n\nvoid main(void){\n  FragColor = texture2D( tTex, vTexCoord );\n}\n';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
